<div
    class="table-management-assets-component"
    [class.pdf-mode]="visualization.PDFMode"
    fxLayout="column"
>
    <div class="table-management-assets-component_section" fxLayout="column">
        <app-highcharts-render
            style="height: 100%"
            [options]="options"
            [visualization]="visualization"
            [series]="seriesData"
            [points]="pointsData"
            [company]="company"
        ></app-highcharts-render>
    </div>
    <div class="table-management-assets-component_section" fxLayout="column">
        <div
            class="table-management-assets-component_section-collapses"
            fxLayout="column"
        >
            @for (table of tableData; track $index) {
                <dsn-expand-collapse
                    [isExpanded]="isExpanded[$index]"
                    [icon]="''"
                    [label]="table.title"
                    [type]="'transparent'"
                    [fontSize]="'medium'"
                    (toggle)="onToggle($event)"
                >
                    <ul
                        class="table-management-assets-component_list"
                        fxLayout="column"
                        [class..pdf-mode]="visualization.PDFMode"
                    >
                        @for (row of table.rows; track $index) {
                            <li [class.padding-pdf]="visualization.PDFMode">
                                <div
                                    class="table-value"
                                    fxLayout="row"
                                    fxLayoutAlign="space-between center"
                                >
                                    <div
                                        class="table-value_title"
                                        [class.pdf-mode]="visualization.PDFMode"
                                        fxLayout="column"
                                    >
                                        <span
                                            [class.text-12-semi-bold]="
                                                !visualization.PDFMode
                                            "
                                            [class.text-10-semi-bold]="
                                                visualization.PDFMode
                                            "
                                            >{{ row.label }}</span
                                        >

                                        @if (row.percentage) {
                                            <span class="text-10-regular"
                                                >Depreciação do estoque:
                                                <span class="value-percent">{{
                                                    row.percentage
                                                }}</span></span
                                            >
                                        }
                                    </div>
                                    <div
                                        class="table-value_unit"
                                        [class]="{
                                            'align-self': row.percentage
                                        }"
                                        fxLayout="column"
                                        fxLayoutAlign="end center"
                                    >
                                        <span
                                            [class.text-12-regular]="
                                                !visualization.PDFMode
                                            "
                                            [class.text-10-regular]="
                                                visualization.PDFMode
                                            "
                                            >{{ row.value }}</span
                                        >
                                    </div>
                                </div>
                            </li>
                        }

                        <li
                            class="bg-primary"
                            [class.padding-pdf]="visualization.PDFMode"
                        >
                            <div
                                class="table-value"
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                            >
                                <div
                                    class="table-value_title"
                                    fxLayout="column"
                                >
                                    <span
                                        [class.text-12-semi-bold]="
                                            !visualization.PDFMode
                                        "
                                        [class.text-10-semi-bold]="
                                            visualization.PDFMode
                                        "
                                        >Total</span
                                    >
                                </div>
                                <div class="table-value_unit" fxLayout="column">
                                    <span
                                        [class.text-12-semi-bold]="
                                            !visualization.PDFMode
                                        "
                                        [class.text-10-semi-bold]="
                                            visualization.PDFMode
                                        "
                                        >{{ table.total }}</span
                                    >
                                </div>
                            </div>
                        </li>
                    </ul>
                </dsn-expand-collapse>
            }
        </div>
    </div>
</div>
